import { render } from "src/website-apps/shared/utils/render";
import { HomeRoot } from "./root";

render(<HomeRoot />);
